export function Kbd({ children }: { children: string }) {
  return <kbd className="rounded border border-border bg-hover px-1.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wide text-muted dark:border-border-dark dark:bg-hover-dark dark:text-muted-dark">{children}</kbd>;
}
